// Season picker — a small list, so a plain native select is enough. Seasons come
// most-recent first from /seasons.

import type { SeasonSummary } from "@catbento/shared";
import { theme } from "../lib/theme.js";

export default function SeasonSelect({
  seasons,
  selectedId,
  onSelect,
  loading,
}: {
  seasons: SeasonSummary[];
  selectedId: number | null;
  onSelect: (id: number) => void;
  loading: boolean;
}) {
  return (
    <select
      aria-label="Select a season"
      value={selectedId ?? ""}
      disabled={loading || seasons.length === 0}
      onChange={(e) => onSelect(Number(e.target.value))}
      style={{
        background: theme.input,
        color: theme.ink,
        border: `1px solid ${theme.borderInput}`,
        borderRadius: 8,
        padding: "8px 12px",
        fontSize: 14,
        minWidth: 130,
        cursor: "pointer",
      }}
    >
      {loading && <option value="">Loading…</option>}
      {!loading && seasons.length === 0 && <option value="">No seasons</option>}
      {seasons.map((s) => (
        <option key={s.id} value={s.id}>
          {s.name}
        </option>
      ))}
    </select>
  );
}
